const STATUSPAGE_STATUS_MAP = {
  operational: 'OK',
  degraded_performance: 'WARNING',
  partial_outage: 'WARNING',
  major_outage: 'ERROR',
  under_maintenance: 'MAINTENANCE',
};

const STATUSIO_STATUS_MAP = {
  100: 'OK',
  300: 'WARNING',
  400: 'WARNING',
  500: 'ERROR',
  600: 'ERROR',
};

const OCI_STATUS_MAP = {
  NormalPerformance: 'OK',
  DegradedPerformance: 'WARNING',
  ServiceDisruption: 'ERROR',
  MaintenanceInProgress: 'MAINTENANCE',
};

async function fetchJson(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

async function fetchStatuspageSource(source) {
  const data = await fetchJson(`${source.url}/api/v2/summary.json`);

  if (source.componentId) {
    const component = data.components?.find(c => c.id === source.componentId);
    if (component) {
      return {
        name: source.name,
        status: STATUSPAGE_STATUS_MAP[component.status] || 'OK',
        componentName: component.name,
      };
    }
  }

  const indicator = data.status?.indicator;
  return {
    name: source.name,
    status: indicator === 'none' ? 'OK' : (indicator === 'critical' ? 'ERROR' : 'WARNING'),
    componentName: data.status?.description,
  };
}

async function fetchStatusioSource(source) {
  const data = await fetchJson(
    `https://api.status.io/1.0/status/${source.statusioId}`
  );

  const overall = data.result?.status_overall;
  const code = Number(overall?.status_code);

  return {
    name: source.name,
    status: STATUSIO_STATUS_MAP[code] || 'OK',
    componentName: overall?.status,
  };
}

async function fetchOcistatusSource(source) {
  const data = await fetchJson(
    `${source.url}/api/v2/components.json`
  );

  const region = data.regionHealthReports?.find(
    r => r.regionId === source.regionId
  );
  if (!region) {
    return { name: source.name, status: 'ERROR', componentName: 'Region not found' };
  }

  const service = region.serviceHealthReports?.find(
    s => s.serviceId === source.serviceId
  );
  if (!service) {
    return { name: source.name, status: 'ERROR', componentName: 'Service not found' };
  }

  return {
    name: source.name,
    status: OCI_STATUS_MAP[service.serviceStatus] || 'OK',
    componentName: service.serviceName,
  };
}

const FETCHERS = {
  statuspage: fetchStatuspageSource,
  statusio: fetchStatusioSource,
  ocistatus: fetchOcistatusSource,
};

export function fetchExternalSource(source) {
  const fetcher = FETCHERS[source.type];
  if (!fetcher) return Promise.reject(new Error(`Unknown source type: ${source.type}`));
  return fetcher(source);
}
